import { Flex, Box, Text, Image } from "@chakra-ui/react";
import klpLogo from "./images/KLP_CIRCLE0.svg";
import TheMenu from "./TheMenu";

const EarnDropDown = ({ isCollapse, inDrawer }) => {
  const menuList = [
    {
      title: "KLP Pool",
      subTitle:
        "KLP Providers earn $BNB/$ETH fees from swaps and leveraged trading",
      icon: klpLogo,
      onClick: () => {
        window.open("https://app.ktx.finance/earn?type=klp", "_blank");
      },
    },
    {
      title: "Staking & Rewards",
      subTitle:
        "Stake $KTC and $esKTC to earn additional platform revenue and rewards.",
      icon: "ktc_rewards.png",
      onClick: () => {
        window.open("https://app.ktx.finance/earn?type=ktc", "_blank");
      },
    },
  ];

  const EarnItem = ({ icon, title, subTitle }) => {
    if (inDrawer) {
      return (
        <Flex
          gap="16px"
          width="252px"
          position="relative"
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text fontSize={"sm"} lineHeight={"140%"} flex={1}>
            {title}
          </Text>
        </Flex>
      );
    }
    return (
      <Flex gap="16px" width="308px" position="relative" alignItems={"center"}>
        <Image src={icon} width="32px" height="32px" />
        <Box>
          <Flex justifyContent={"space-between"}>
            <Text fontSize={"sm"} lineHeight={"140%"} fontWeight={500}>
              {title}
            </Text>
          </Flex>
          <Text fontSize={"xs"} mt={"4px"} color={"gray.light"}>
            {subTitle}
          </Text>
        </Box>
      </Flex>
    );
  };

  return (
    <TheMenu
      menuList={menuList}
      isCollapse={isCollapse}
      ItemCmp={EarnItem}
      menuLabel="Earn"
      inDrawer={inDrawer}
    />
  );
};

export default EarnDropDown;
